import {
    $createParagraphNode,
    $getSelection,
    $isRangeSelection,
    $isTextNode,
    ElementNode,
    LexicalEditor,
} from "lexical"
import {$getNearestBlockElementAncestorOrThrow} from "@lexical/utils"
import {$isHeadingNode, $isQuoteNode} from "@lexical/rich-text"
import {$isDecoratorBlockNode} from "@lexical/react/LexicalDecoratorBlockNode"
import {$isBadgeNode} from "../plugins/highlight/badge/badge-plugin"
import {$isFontColorNode} from "../plugins/highlight/font-color/font-color-plugin"

const debug = false
// const debug = "lexicalClearFormatting"

export function lexicalClearFormatting(editor: LexicalEditor) {
    debug && console.log(debug, 'process')

    editor.update(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
            const anchor = selection.anchor
            const focus = selection.focus
            const nodes = selection.getNodes()

            if (anchor.key === focus.key && anchor.offset === focus.offset) {
                return
            }

            nodes.forEach((node:any, idx) => {
                // We split the first and last node by the selection
                // So that we don't format unselected text inside those nodes
                if ($isTextNode(node)) {
                    if (idx === 0 && anchor.offset !== 0) {
                        node = node.splitText(anchor.offset)[1] || node
                    }
                    if (idx === nodes.length - 1) {
                        node = node.splitText(focus.offset)[0] || node;
                    }

                    if (node.__style !== '') {
                        node.setStyle('');
                    }
                    if (node.__format !== 0) {
                        node.setFormat(0);
                        $getNearestBlockElementAncestorOrThrow(node).setFormat('');
                    }
                } else if ($isHeadingNode(node) || $isQuoteNode(node)) {
                    node.replace($createParagraphNode(), true)
                } else if ($isBadgeNode(node) || $isFontColorNode(node)) {
                    clearNodeFormatting(node)
                }else if ($isDecoratorBlockNode(node)) {
                    node.setFormat('')
                }
            })
        }
    })
}

export function clearNodeFormatting(node:ElementNode) {
    const children = node.getChildren()

    for (let i = 0; i < children.length; i++) {
        node.insertBefore(children[i])
    }

    node.remove()
}
